<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="`${title}:${insertData.recordId}`">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.recordId'
              label='流水号'
              disabled
            />
          </div>
          <div class='flex md6 sm6 xs12'>
            <va-input
              v-model='insertData.uid'
              label='uid'
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.nickname"
              label="昵称"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.opType"
              label="操作类型"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.count"
              label="数量"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.eventId"
              label="业务id"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.eventType"
              label="业务类型"
              disabled
            />
          </div>

          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.vmType"
              label="积分类型"
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.createTime"
              label="创建时间"
              disabled
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="$router.push({ name: 'listVirtualMoneyRecord'})">
            返回
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { computeEventType, computeOpType, computeVmType, copyObject, formatTime } from '@/utils/common'
import { EVENT_TYPES, OP_TYPES, VM_TYPES } from '@/utils/constants'
import virtualMoneyApi from '@/api/virtualMoney'

export default {
  data () {
    return {
      insertData: {
        recordId: '',
        eventId: null,
        eventType: null,
        opType: null,
        vmType: null,
        count: 0,
        uid: '',
        nickname: '',
        createTime: 0,
      },
      message: ['Required field'],
      error: {
      },
      title: '积分记录',
      submitButtonStatus: true,
      eventTypes: EVENT_TYPES,
      opTypes: OP_TYPES,
      vmTypes: VM_TYPES,
    }
  },
  created () {
    this.getVirtualMoneyRecord()
  },
  computed: {
  },
  methods: {
    getVirtualMoneyRecord () {
      const params = this.$route.params
      if (params.recordId == null) {
        return
      }
      virtualMoneyApi.getVirtualMoneyRecord(params.recordId).then(response => {
        copyObject(response.virtualMoneyRecord, this.insertData)
        this.insertData.createTime = formatTime(this.insertData.createTime)
        this.insertData.eventType = computeEventType(this.insertData.eventType).text
        this.insertData.opType = computeOpType(this.insertData.opType).text
        this.insertData.vmType = computeVmType(this.insertData.vmType).text
        if (!this.insertData.eventId) {
          this.insertData.eventId = '无'
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    clickCancel () {
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
